import { Radio, Select, Spin } from 'antd';
import ErrorMessage from '../ErrorMessage';
import { useUiData } from '../../lib/hooks';
const uiKeys = ['grades'];
const GradePicker = ({
  grades,
  selected,
  mode = "radio",
  includeOverall = true,
  onChange
}) => {
  const {
    isPending,
    isError,
    data
  } = useUiData(uiKeys);
  if (isPending) {
    return <Spin size="small" />;
  }
  if (isError) {
    return <ErrorMessage message="There was an error during loading app data. Reload the page to try again." />;
  }
  const gradesList = data.grades.filter(g => grades === undefined || grades.includes(g.id));
  if (includeOverall && gradesList.length > 1) {
    gradesList.unshift({
      id: undefined,
      name: mode === 'dropdown' ? 'Any Grade' : 'Overall'
    });
  }
  if (['dropdown', 'multi'].includes(mode)) {
    return <Select value={selected} onChange={onChange} mode={mode === 'multi' ? 'multiple' : null}>
				{gradesList.map(g => <Select.Option value={g.id} key={g.name}>{g.name}</Select.Option>)}
			</Select>;
  }
  return <>
			Grades:
			{' '}
			<Radio.Group size="default" buttonStyle="solid" onChange={e => onChange(e.target.value)} options={gradesList.map(grade => ({
      label: grade.name,
      value: grade.id
    }))} optionType="button" buttonStyle="solid" value={selected} data-sentry-element="unknown" data-sentry-source-file="GradePicker.jsx" />
			{' '}
		</>;
};
export default GradePicker;